'use client';

import { type ReactNode } from 'react';
import { motion, type Variants } from 'motion/react';

export interface ServiceCardProps {
  media: ReactNode;
  headerTitle: string;
  headerDescription: string;
  revealVariants?: Variants;
}

export default function ServiceCard({
  media,
  headerTitle,
  headerDescription,
  revealVariants,
}: ServiceCardProps) {
  return (
    <motion.div
      variants={revealVariants}
      className="group relative aspect-video overflow-hidden rounded-xl border-0 bg-transparent p-0 text-left transition-all duration-300 ease-in-out focus-visible:outline-none dark:border dark:border-white/10"
    >
      <div className="absolute inset-0">{media}</div>
      <div className="pointer-events-none absolute inset-0 z-20 bg-[linear-gradient(180deg,rgba(0,0,0,0.24)_0%,rgba(0,0,0,0)_26%,rgba(0,0,0,0)_38%,rgba(0,0,0,0.82)_100%)]" />
      <div className="relative flex h-full flex-col justify-between p-4 z-40">
        <div className="mt-auto flex flex-col space-y-0.5 [text-shadow:0_1px_14px_rgba(0,0,0,0.85)]">
          <h3
            className={`text-base font-medium tracking-tight text-white sm:text-lg ${headerDescription ? '' : 'leading-none'}`}
          >
            {headerTitle}
          </h3>
          {headerDescription ? (
            <p className="line-clamp-2 text-pretty text-xs leading-tight font-light text-white/90">
              {headerDescription}
            </p>
          ) : null}
        </div>
      </div>
    </motion.div>
  );
}
